<template>
	<div
		class="home-wrapper"
		:style="
			'background: url(' +
			ContainerBg +
			') no-repeat center top / 100% 21.0625rem;'
		"
	>
		<HomeContainerGreeting />

		<div class="home-content u-container">
			<HomeContainerUserResrvation />
			<HomeContainerBanner />
		</div>
	</div>
</template>

<script>
import HomeContainerGreeting from './HomeContainerGreeting';
import HomeContainerUserResrvation from './HomeContainerUserResrvation';
import HomeContainerBanner from './HomeContainerBanner';

import ContainerBg from '@/assets/images/home/bg.png';

export default {
	components: {
		HomeContainerGreeting,
		HomeContainerUserResrvation,
		HomeContainerBanner,
	},
	data() {
		return {
			ContainerBg,
		};
	},
};
</script>

<style scoped>
.home-wrapper {
	padding-bottom: 1rem;
}
</style>
